import { helpCharm_ariaLabel } from 'owa-locstrings/lib/strings/helpcharm_arialabel.locstring.json';
import loc from 'owa-localize';
import HeaderCharm from './HeaderCharm';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';
import { HelpPane } from 'owa-header-pane';
import { HeaderCharmType } from 'owa-header-store';
import { toggleCharm } from 'owa-header-store';

import * as React from 'react';
import { showO365ShellHeader } from 'owa-suite-header-apis';

@observer
export default class HelpCharm extends React.Component<{}, {}> {
    render() {
        return (
            <HeaderCharm
                key="help"
                icons={{ iconName: ControlIcons.Help }}
                ariaLabel={loc(helpCharm_ariaLabel)}
                title={loc(helpCharm_ariaLabel)}
                behavior={{
                    paneComponent: showO365ShellHeader() ? null : HelpPane,
                    charm: HeaderCharmType.HelpCharm,
                    onClick: this.onHelpCharmClicked,
                }}
            />
        );
    }

    private onHelpCharmClicked = () => {
        if (!showO365ShellHeader()) {
            toggleCharm(HeaderCharmType.HelpCharm);
        }
    };
}
